import { all } from "ramda";
const ZERO_STATE_CHANGE = {
    closedCount: 0,
    connectedCount: 0,
    connectingCount: 0,
    disconnectedCount: 0,
    failedCount: 0,
    newCount: 0,
};
const allZeros = all((x) => x === 0);
export class WebrtcConnectionStateMetricsCollector {
    stateChangeCount = new Map();
    start() { }
    stop() { }
    resetCollection() {
        for (const serverURL of this.stateChangeCount.keys()) {
            this.resetStateChangeCount(serverURL, "send");
            this.resetStateChangeCount(serverURL, "recv");
        }
    }
    outputMetrics() {
        const metrics = [];
        for (const [serverURL, stats] of this.stateChangeCount) {
            if (!allZeros(Object.values(stats["send"]))) {
                metrics.push({
                    name: "webrtc-connection-change",
                    values: { direction: "send", serverURL, ...stats["send"] },
                });
            }
            if (!allZeros(Object.values(stats["recv"]))) {
                metrics.push({
                    name: "webrtc-connection-change",
                    values: { direction: "recv", serverURL, ...stats["recv"] },
                });
            }
        }
        return metrics;
    }
    countStateChange(serverURL, state, direction) {
        if (!this.stateChangeCount.get(serverURL)) {
            this.stateChangeCount.set(serverURL, {
                send: { ...ZERO_STATE_CHANGE },
                recv: { ...ZERO_STATE_CHANGE },
            });
        }
        const serverStats = this.stateChangeCount.get(serverURL);
        if (serverStats) {
            serverStats[direction][`${state}Count`] += 1;
        }
    }
    resetStateChangeCount(serverURL, direction) {
        const stateChangeCount = this.stateChangeCount.get(serverURL);
        if (stateChangeCount) {
            stateChangeCount[direction] = { ...ZERO_STATE_CHANGE };
        }
    }
}
//# sourceMappingURL=WebrtcConnectionStateMetricsCollector.js.map